import { z } from "zod";
import { BillingOrderProductItemSchema } from "./billing-order-product-item";

const fieldDate = z
  .string()
  .optional()
  .refine(
    (value?: string) => {
      try {
        if (!value) {
          return true;
        }
        const date = new Date(value);
        return !isNaN(date.getTime());
      } catch {
        return false;
      }
    },
    {
      message: "Invalid date format",
    },
  )
  .transform((value?: string) => value && new Date(value));

export const BillingOrderItemSchema = z.object({
  Id: z.string(),
  AccountId: z.string().optional(),
  AccountName: z.string().optional(),
  BillToCity: z.string().optional(),
  BillTo: z.string().optional(),
  BillToCountry: z.string().optional(),
  BillToLine1: z.string().optional(),
  BillToLine2: z.string().optional(),
  BillToPostalCode: z.string().optional(),
  BillToStateOrProvince: z.string().optional(),
  DiscountAmount: z.number().optional(),
  DiscountPercentage: z.number().optional(),
  EmailAddress: z.string().optional(),
  ShippingMethodCode: z.number().optional(),
  OrderStatusCode: z.number().optional(),
  TotalDetailAmount: z.number().optional(),
  TotalAmount: z.number().optional(),
  Number: z.string().optional(),
  ShipToCity: z.string().optional(),
  ShipTo: z.string().optional(),
  ShipToCountry: z.string().optional(),
  ShipToLine1: z.string().optional(),
  ShipToLine2: z.string().optional(),
  ShipToPostalCode: z.string().optional(),
  ShipToStateOrProvince: z.string().optional(),
  Created: fieldDate,
  Items: BillingOrderProductItemSchema.array().optional(),
  TotalAmountLessFreight: z.number().optional(),
  TotalDiscountAmount: z.number().optional(),
  TotalLineItemAmount: z.number().optional(),
  TotalLineItemDiscountAmount: z.number().optional(),
  TotalTax: z.number().optional(),
});

export type BillingOrderItemType = z.infer<typeof BillingOrderItemSchema>;
